import React, { forwardRef } from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { ControlledColorFilter } from '@vlabs/monokit/shared/ui/controlled-color-filter';
import { ControlledOptionsFilter } from '@vlabs/monokit/shared/ui/controlled-options-filter';
import type { Option } from '@vlabs/monokit/shared/ui/options-filter';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { useTranslation } from 'react-i18next';

import { useWorkspaceFilters } from '../../useWorkspaceFilters';
import st from '../FilterPopovers.module.sass';

function UpperFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { t } = useTranslation();
  const { filters, updateFilters } = useWorkspaceFilters();
  const colors = filters.upper_clothing_colors ?? [];
  const sleeves = filters.sleeve_lengths ?? [];
  const colorOptions = EVENT_ENUMS.UPPER_BODY.UPPER_CLOSING_COLOR.raw as Option[];
  const sleeveOptions = EVENT_ENUMS.UPPER_BODY.SLEEVE.raw as Option[];

  const reset = () => updateFilters({
    sleeve_lengths: undefined,
    upper_clothing_colors: undefined,
  });

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={colors.length === 0 && sleeves.length === 0}
      onClickReset={reset}
      ref={ref}
    >
      <ControlledColorFilter
        label={t('events:upper_clothing_colors')}
        onChange={(value) => updateFilters({
          upper_clothing_colors: value.length > 0 ? value : undefined,
        })}
        options={colorOptions}
        value={colors}
      />
      <div className={st.SectionDivider} />
      <ControlledOptionsFilter
        label={t('events:sleeve')}
        name="sleeve_lengths"
        onChange={(value) => updateFilters({
          sleeve_lengths: value.length > 0 ? value : undefined,
        })}
        options={sleeveOptions}
        value={sleeves}
      />
    </PopoverWithButton>
  );
}

const UpperFilterPopoverWithRef = forwardRef(UpperFilterPopover);
export { UpperFilterPopoverWithRef as UpperFilterPopover };
